
import * as vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      openedModal: false,
    };
  },
  methods: {
    showModal() {
      this.openedModal = true;

      setTimeout(() => {
        this.setVideoAttributes();
      }, 300);
    },
    closeModal() {
      this.openedModal = false;
    },
    setVideoAttributes() {
      const video = document.getElementsByTagName("video");

      const attributes = {
        playsinline: "",
        preload: "auto",
        autoplay: "",
        loop: "",
      };

      if (video && video[0]) {
        video[0].addEventListener("suspend", () => {
          video[0].play();
        });

        video[0].playsinline = true;
        video[0].load();
        video[0].play();

        Object.keys(attributes).forEach((attr) => {
          video[0].setAttribute(attr, attributes[attr]);
        });
      }
    },
  },
};
